<template>
  <v-card
    class="token-list-card d-flex flex-column pa-2 pa-sm-3 pa-lg-5 align-items-start bg-transparent"
    variant="outlined"
    :to="{
      name: ROUTE_TOKEN_DETAILS,
      params: { tokenName: token.symbol },
    }"
  >
    <div class="d-flex align-center ga-3 ga-sm-4 ga-md-6">
      <TokenImage :cid="token.image_thumbnail" class="image" />

      <div class="d-flex flex-column ga-1 ga-md-4 flex-1-1-0">
        <div class="d-flex flex-column ga-1">
          <div class="token-name text-h3">
            {{ token.name }} ({{ token.symbol }})
          </div>
          <p v-if="token.description" class="description">
            {{ token.description }}
          </p>
        </div>
        <div class="d-flex flex-column ga-1 text-body-2 text-md-body-1">
          <div class="d-flex ga-1 flex-wrap">
            <span class="label opacity-60">{{ $t("common.price") }}:</span>
            <PriceDataFormatter
              :price-data="tokenData.price_data"
              hide-fiat-price
            />
          </div>
          <div class="d-flex ga-1 flex-wrap">
            <span class="label opacity-60">{{ $t("common.marketCap") }}:</span>
            <span>
              <PriceDataFormatter
                :price-data="tokenData.price_data"
                bignumber
                row
                hide-ae-price
              />
            </span>
          </div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script setup lang="ts">
import { defineProps } from "vue";
import { useLiveTokenData } from "@/composables";
import { TokenDto } from "@/api/generated";
import { ROUTE_TOKEN_DETAILS } from "@/utils/constants";

import PriceDataFormatter from "@/components/Common/Pricing/PriceDataFormatter.vue";
import TokenImage from "@/components/Tokens/TokenImage.vue";

const props = defineProps({
  token: { type: Object as () => TokenDto, required: true },
});

const { tokenData } = useLiveTokenData({
  token: props.token,
});
</script>

<style scoped lang="scss">
@use "@/styles/variables" as *;

.token-list-card {
  height: 100%;

  .description {
    color: #a3a3a3;
    display: block;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    max-height: 3em;
    line-height: 1.5em;
  }

  .image {
    width: 100px;
    height: 100px;
  }

  .label {
    font-family: $font-mono;
  }

  @media (min-width: 600px) {
    .image {
      width: 150px;
      height: 150px;
    }
  }
}
</style>
